import axios from 'axios'

export const createMembership = async (data:any) => {
  const url = '/api/v1/membership'
  const createMembershipResponse = await axios.post(url, data, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
  .then((response:any) => {
    return response
  })
  .catch((error:any) => {
    return error.response
  })
  return createMembershipResponse
}

export const saveMembership = async (data:any) => {
  const url = `/api/v1/membership/${data.public_id}`
  const recaptchaToken = ''; // NOTE: recaptacha can be added here
  const saveMembershipResponse = await axios.put(url, data, {
    headers: {
      'Content-Type': 'application/json',
      'User-Response': `${ recaptchaToken }`
    }
  })
  .then((response:any) => {
    return response
  })
  .catch((error:any) => {
    return error.response
  })
  return saveMembershipResponse
}

export const getMembership = async (id:any) => {
  const url = `/api/v1/membership/${id}`
  const getMembershipResponse = await axios.get(url)
  .then((response:any) => {
    return response
  })
  .catch((error:any) => {
    return error.response
  })
  return getMembershipResponse
}

export const getTitles = async () => {
  let titles = await axios.get('/api/v1/settings')
  return JSON.parse(titles.data[0].titles)
}